// frontend/src/data/supportPackages.js
import pioneerIcon from "../assets/icons/pioneer.png";

import explorerIcon from "../assets/icons/explorer.png";

import elacorianIcon from "../assets/icons/elacorian.png";

import sonIcon from "../assets/icons/son.png";

import creatureIcon from "../assets/icons/creature.png";

import loreIcon from "../assets/icons/lore.png";

export const SUPPORT_PACKAGES = [
  {
    id: "pioneer",

    icon: pioneerIcon,

    name: "Pioneer",

    price: 16.8,

    rewards: [
      "Get 1 Steam key for Elacoria.",
      "Your name forever in credits as a Elacoria Supporter.",
    ],
  },

  {
    id: "explorer",

    icon: explorerIcon,

    name: "Explorer: Alpha & Beta Access",

    price: 26.8,

    rewards: [
      "Include previous rewards",
      "Early access to Alpha & Beta",
      "Credits as Elacoria Tester",
    ],
  },

  {
    id: "elacorian",

    icon: elacorianIcon,

    name: "Elacorian",

    price: 56.8,

    rewards: [
      "Include previous rewards",
      "3 Steam keys total",
      "Credits as Elacorian",
    ],
  },

  {
    id: "son_of_elacoria",

    icon: sonIcon,

    name: "Son of Elacoria",

    price: 268,

    rewards: ["1 Steam key", "Alpha & Beta access", "Your name becomes an NPC"],
  },

  {
    id: "creature_creator",

    icon: creatureIcon,

    name: "Creature Creator",

    price: 568,

    rewards: ["1 Steam key", "Alpha & Beta access", "Create your own creature"],
  },

  {
    id: "lore_creator",

    icon: loreIcon,

    name: "Lore Creator",

    price: 2568,

    rewards: [
      "All Elacorian rewards",
      "Design story & NPC with developers",
      "Only 2 slots",
    ],
  },
];
